import { Center, Loader } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import React from 'react'
import type { FC } from 'react'

import styles from './FormLoading.module.css'

type Props = {
  selectedContracts: {
    label: string
    value: number
  }[]
}
const FormLoading: FC<Props> = ({ selectedContracts }) => {
  const { t } = usePlanningFormTranslation()
  const isMulti = !!selectedContracts?.length
  return (
    <Center className={styles.Container}>
      <Loader />
      <span className={styles.Label}>
        {!isMulti && t('restForm.loading')}
        {isMulti && t('restForm.loadingMulti')}
      </span>
    </Center>
  )
}

export default FormLoading
